// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___uXr0k","container_1":"container_1___2HTNk","container_2":"container_2___3HvPO","wp-block-cgb-block-cec-blocks":"wp-block-cgb-block-cec-blocks___2L5x-"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/news/styles.module.scss
// module id = 326
// module chunks = 0